import { DateTime } from 'luxon';
import { parseDate } from 'model';

export const isPostPromoted = ({ startDate, endDate }: { startDate: string | null; endDate: string | null }) => {
	const now = parseDate(DateTime.now().toISO().substring(0, 10));

	let isPromoted = false;
	let willBePromoted = false;

	if (startDate && endDate) {
		// Though we should have done the date math properly such that
		// startDate and endDate should be midnight local time, we lop off the time
		// to ensure that we are comparing the same thing.
		const promotionStartDate = parseDate(startDate.substring(0, 10));
		const promotionEndDate = parseDate(endDate.substring(0, 10));
		isPromoted = now.diff(promotionStartDate).milliseconds >= 0 && now.diff(promotionEndDate).milliseconds <= 0;
		willBePromoted = now.diff(promotionStartDate).milliseconds < 0;
	}

	return {
		isPromoted,
		willBePromoted
	};
};
